module.exports = __webpack_public_path__ + "assets/img/eye.4b36b015.svg";